import { cn } from '@/lib/utils';

export interface PageHeaderCommandWellProps {
  /** Action buttons, selects, links, or grouped controls */
  children?: React.ReactNode;
  /** Additional CSS classes */
  className?: string;
}

/**
 * PageHeaderCommandWell - Action buttons and controls section
 *
 * Renders children with consistent right-alignment and spacing.
 * Parent is responsible for grouping controls (e.g., with separators).
 *
 * @example Simple buttons
 * <PageHeaderCommandWell>
 *   <Button variant="primary">Create</Button>
 *   <Button variant="secondary">Import</Button>
 * </PageHeaderCommandWell>
 *
 * @example With grouped controls
 * <PageHeaderCommandWell>
 *   <Select options={...} />
 *   <div className="flex gap-1 border-l border-border pl-2">
 *     <Button>Dim</Button>
 *     <Button>Fullscreen</Button>
 *   </div>
 *   <Button variant="danger">Delete</Button>
 * </PageHeaderCommandWell>
 */
export function PageHeaderCommandWell({ children, className }: PageHeaderCommandWellProps) {
  return <nav className={cn('flex gap-2 items-center', className)}>{children}</nav>;
}
